import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { BoxV4 } from '@labrav/react-components'

import { useStyles } from './ContractDetails.styles'
import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface ContractDetailsProps {
  combinedFormData: CombinedFormState
}

export default function ContractDetails({
  combinedFormData,
}: ContractDetailsProps) {
  const { classes } = useStyles()

  return (
    <BoxV4
      style={{ padding: '32px' }}
      heading="Contract duration"
      headingIcon={
        <FontAwesomeIcon
          icon={faListUl}
          style={{ width: '18px', height: '14px' }}
        />
      }
      variant="small"
      headingVariant="small"
    >
      <div className={classes.section}>
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Contract start date'}
                value={
                  combinedFormData.cppoData.variableStartDate
                    ? 'Offer acceptance date'
                    : 'Specific future date'
                }
                keyName={'cppoData.variableStartDate'}
              />
              <DetailInfo
                title={'Start date'}
                value={
                  (!combinedFormData.cppoData.variableStartDate
                    ? combinedFormData.cppoData.agreementStartDate
                    : '-') as string
                }
                keyName={'cppoData.agreementStartDate'}
              />
            </>
          }
        />
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Duration type'}
                value={
                  String(
                    combinedFormData.resellerAgreementData
                      .contractDurationTimeUnit
                  )
                    .charAt(0)
                    .toUpperCase() +
                  String(
                    combinedFormData.resellerAgreementData
                      .contractDurationTimeUnit
                  )
                    .slice(1)
                    .toLowerCase()
                }
                keyName={'resellerAgreementData.contractDurationTimeUnit'}
              />
              <DetailInfo
                title={'Duration number'}
                value={
                  combinedFormData.resellerAgreementData
                    .contractDurationInMonthsForEndCustomer as unknown as string
                }
                keyName={
                  'resellerAgreementData.contractDurationInMonthsForEndCustomer'
                }
              />
            </>
          }
        />
      </div>
    </BoxV4>
  )
}
